import { useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Avatar,
  Typography,
  Button,
  Collapse,
  Chip,
  Stack,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import TagIcon from "@mui/icons-material/Tag";
import GroupIcon from "@mui/icons-material/Group";

export const FeedbackCard = ({ card, currentSection }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandedCard = (e) => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  return (
    <Card
      sx={{
        mb: 3,
        boxShadow: 3,
        maxWidth: "100%",
        cursor: "pointer",
        borderLeft: '4px solid "#2196F3',
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: 6,
        },
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
            width: "100%",
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                fontFamily: "Montserrat, sans-serif",
                color: "#014F6D",
                maxWidth: "100%",
                wordBreak: "break-word",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {card.assunto}
            </Typography>

            <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
              <Chip
                icon={<TagIcon color="#2196F3" />}
                label={card.feedbackTipoNome}
                size="small"
                variant="outlined"
                sx={{
                  color: "#2196F3",
                  border: "1px solid #2196F3",
                  padding: "5px",
                }}
              />
              <Chip
                icon={<GroupIcon color="#FF6B35" />}
                label={card.feedbackSetorNome}
                size="small"
                sx={{
                  color: "#FF6B35",
                  border: "1px solid #FF6B35",
                  padding: "5px",
                }}
                variant="outlined"
              />
            </Stack>
          </Box>

          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            {new Date(card.criado_em).toLocaleDateString("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })}
          </Typography>
        </Box>

        {currentSection === "Feedbacks Recebidos" && (
          <>
            <Typography
              variant="caption"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                color: "#666",
                display: "block",
              }}
            >
              Enviado por: {card.usuarioCriadorNome || "Anônimo"}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                color: "#666",
                display: "block",
              }}
            >
              Enviado para: {card.usuarioReceptorNome || "Todos do setor"}
            </Typography>
          </>
        )}
        <Divider sx={{ my: 1 }} />

        <Collapse in={expanded} collapsedSize={72}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              whiteSpace: "pre-line",
              wordBreak: "break-word",
              color: "text.primary",
              lineHeight: 1.6,
            }}
          >
            {card.texto}
          </Typography>
        </Collapse>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <Button
            onClick={handleExpandedCard}
            startIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            sx={{
              color: "#014F6D",
              fontFamily: "Montserrat, sans-serif",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "rgba(1, 79, 109, 0.08)",
              },
            }}
            size="small"
          >
            {expanded ? "Mostrar menos" : "Mostrar mais"}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
